import React from "react";
import { Box, Typography, Grid, Paper, Avatar } from "@mui/material";

export const StatCard = ({ icon, label, value, iconBgColor, cardBgColor }) => (
  <Paper
    elevation={0}
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      backgroundColor: cardBgColor,
      p: 1,
      borderRadius: 2,
      width: "100%"
    }}
  >
    <Avatar
      sx={{
        bgcolor: iconBgColor,
        width: 40,
        height: 40
      }}
    >
      <img src={icon} alt="icon" style={{ width: 22, height: 18 }} />
      {/* {icon} */}
    </Avatar>
    <Box>
      <Typography variant="body2">{label}</Typography>
      <Typography variant="h7" fontWeight={600}>
        {value}
      </Typography>
    </Box>
  </Paper>
);
